import React from "react";
import formConfig from "../../../config/form";

export default function InfoHeader({ apartment }) {
  const status =
    apartment.availability === "ennakkomarkkinoinnissa" ? "premarketing" : "onsale";
  const innerHtml = {
    __html: apartment.available
      ? formConfig.getHeading(status, "free")
      : formConfig.getHeading(status, "reserved"),
  };

  let apartmentType = "Asunnon";
  if (apartment.type === "AP") {
    apartmentType = "Autopaikan";
  } else if (apartment.type === "VART") {
    apartmentType = "Varaston";
  }

  return (
    <div className="mb-5">
      <h1 className="text-xl">
        {apartment.available
          ? `${apartmentType} varaaminen`
          : "Liity varausjonoon"}
      </h1>
      <div dangerouslySetInnerHTML={innerHtml}></div>
    </div>
  );
}
